const kindByExtension = {
  avif: 'image',
  bmp: 'image',
  gif: 'image',
  jpeg: 'image',
  jpg: 'image',
  png: 'image',
  svg: 'image',
  webp: 'image',

  pdf: 'pdf',

  '7z': 'archive',
  gz: 'archive',
  rar: 'archive',
  tar: 'archive',
  zip: 'archive',

  doc: 'document',
  docx: 'document',
  odt: 'document',
  rtf: 'document',

  csv: 'spreadsheet',
  ods: 'spreadsheet',
  xls: 'spreadsheet',
  xlsx: 'spreadsheet',

  odp: 'presentation',
  ppt: 'presentation',
  pptx: 'presentation',

  md: 'text',
  txt: 'text',

  css: 'code',
  go: 'code',
  html: 'code',
  js: 'code',
  json: 'code',
  py: 'code',
  sh: 'code',
  ts: 'code',
  xml: 'code',
  yaml: 'code',
  yml: 'code',
};

const iconByKind = {
  archive: 'archive',
  code: 'code-icon',
  document: 'file-text',
  image: 'file-image',
  pdf: 'file-pdf',
  presentation: 'file-text',
  spreadsheet: 'file-text',
  text: 'file-text',
};

const readableExtensions = new Set([
  'gif', 'jpeg', 'jpg', 'png', 'webp',
  'bmp', 'tif', 'tiff',
  'pdf',
  'csv', 'css', 'go', 'html', 'js', 'json', 'md',
  'py', 'sh', 'svg', 'ts', 'txt', 'xml', 'yaml', 'yml',
  'docx', 'odp', 'ods', 'odt', 'pptx', 'xlsx',
]);

const reasonByExtension = {
  avif: 'image',
  heic: 'image',
  heif: 'image',

  doc: 'legacyOffice',
  ppt: 'legacyOffice',
  xls: 'legacyOffice',

  rtf: 'richText',

  '7z': 'archive',
  gz: 'archive',
  rar: 'archive',
  tar: 'archive',
  zip: 'archive',
};

// fileName is synthesised on read and absent for a storage object written without one, so
// this is reached with undefined. A leading dot names the file rather than its type.
export const extensionOf = (name) => {
  if (typeof name !== 'string') {
    return '';
  }

  const dot = name.lastIndexOf('.');
  return dot < 1 ? '' : name.slice(dot + 1).toLowerCase();
};

export const attachmentKind = (name) => {
  const extension = extensionOf(name);
  if (extension === '') {
    return 'unknown';
  }

  return kindByExtension[extension] ?? 'generic';
};

export const isImageName = (name) => attachmentKind(name) === 'image';

export const attachmentIcon = (name) => iconByKind[attachmentKind(name)] ?? 'file';

export const unreadableReason = (name) => {
  const extension = extensionOf(name);
  if (extension === '' || readableExtensions.has(extension)) {
    return null;
  }

  return reasonByExtension[extension] ?? 'other';
};
